import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { getInvestments } from '../api/Index'
import './Investments.css'
import PageTitle from '../components/UI/PageTitle'
import Separator from '../components/UI/Separator'

const Investments = () => {
    const navigate = useNavigate();
    const [investments, setInvestments] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchInvestments = async () => {
            setLoading(true);
            setError(null);
            try {
                const response = await getInvestments();
                setInvestments(response.data);
            } catch (err) {
                setError(err.message);
                console.error('Error fetching investments:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchInvestments();
    }, []);

    const handleInvestmentClick = (investmentId) => {
        navigate(`/investment-details?id=${investmentId}`);
    };

    const InvestmentCard = ({ investment }) => {
        return (
            <div 
                className="investment-profile-container"
                onClick={() => handleInvestmentClick(investment._id || investment.id)}
                style={{cursor: 'pointer'}}
            >
                <div className="investment-details">
                    <h3>{investment.name}</h3>
                    <div className="investment-info">
                        <p>Amount Invested: KES: {investment.amountInvested || investment.amount || 'N/A'}</p>
                        <p>Start Date: {investment.startDate ? new Date(investment.startDate).toLocaleDateString() : 'N/A'}</p>
                        <p>End Date: {investment.endDate ? new Date(investment.endDate).toLocaleDateString() : 'N/A'}</p>
                    </div>
                </div>
                <div className="investment-status">
                    {investment.status || 'Active'}
                </div>
            </div>
        )
    }

    if (loading) {
        return (
            <div className="investments">
                <PageTitle title="Investments" />
                <div>Loading investments...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="investments">
                <PageTitle title="Investments" />
                <div style={{color: 'red'}}>Error: {error}</div>
            </div>
        );
    }

    return (
        <div className="investments">
            <PageTitle title="Investments" />
            <div className="investments-profile-container">
                {investments.length === 0 ? (
                    <div>No investments found.</div>
                ) : (
                    investments.map(investment => (
                        <>
                            <InvestmentCard key={investment._id || investment.id} investment={investment} />
                            <Separator />
                        </>
                    ))
                )}
            </div>
        </div>
    )
}

export default Investments